import { useContext } from 'react';
import { SnackbarContext } from './Snackbar';

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
